export const CHART_HEIGHT = 260;

export const CHART_MARGIN = {
  top: 10,
  right: 30,
  left: 10,
  bottom: 20,
} as const;
